import { render, staticRenderFns } from "./ListPayService.vue?vue&type=template&id=3b30836a&scoped=true"
import script from "./ListPayService.vue?vue&type=script&lang=ts"
export * from "./ListPayService.vue?vue&type=script&lang=ts"
import style0 from "./ListPayService.vue?vue&type=style&index=0&id=3b30836a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30836a",
  null
  
)

export default component.exports